import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { StyledWrapper } from './KlarnaPlacementStyles';

var KlarnaPlacement = function KlarnaPlacement(_ref) {
  var price = _ref.price;

  useEffect(function () {
    // Calling this function allows the Klarna Placement tag
    // to appear after React is loaded.
    window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
  }, [price]);

  var purchaseAmount = parseInt(price) * 100;
  return React.createElement(
    StyledWrapper,
    null,
    React.createElement('klarna-placement', {
      'data-key': 'credit-promotion-small',
      'data-locale': 'en-US',
      'data-purchase-amount': purchaseAmount
    })
  );
};

KlarnaPlacement.propTypes = {
  price: PropTypes.number
};

export default KlarnaPlacement;